(ns machtfit.stepchall.leaderboard
  (:require [goog.string :as gstring]
            [machtfit.format :as format]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.leaderboard.nav :as leaderboard.nav]
            [machtfit.stepchall.modal :as modal]
            [machtfit.stepchall.pagination :as pagination]
            [machtfit.stepchall.search :as search]
            [machtfit.stepchall.subs :as subs]
            [machtfit.stepchall.team-members :as team-members]
            [machtfit.translation :refer [tr trn t trp-with-place-holders]]
            [re-frame.core :as rf]))

(rf/reg-sub ::leaderboard-team-by-id
  :<- [::subs/teams-by-id]

  (fn [teams [_ team-id]]
    (teams team-id)))

(defn- open-team-members-modal [db team-id]
  (assoc-in db [:ui :page :team-id] team-id))

(rf/reg-event-fx ::team-clicked
  (fn [{:keys [db]} [_ team-id]]
    (-> {:db (open-team-members-modal db team-id)}
        api-events/api-requests-on-stepchall-event)))

(defn- team-row [{:keys [id name rank color step-counts member-count
                         goal-reached-date animation-pos]}]
  (let [challenge-started? @(rf/subscribe [::subs/challenge-started?])
        team-step-count (:total step-counts)
        rank (cond
               (not challenge-started?) nil
               (zero? team-step-count) "-"
               :else rank)
        own-team? (= id @(rf/subscribe [:get [:stepchall :team :id]]))]
    [:div.sc_leaderboard-row {:class (when own-team? "own")
                              :id (when own-team? "leaderboard-own-team")
                              :style {:animation-delay (str (/ animation-pos 10) "s")}
                              :on-click #(rf/dispatch [::team-clicked id])}
     [:div.rank rank]
     [:div.color [:span.team-color {:style {:background-color color}}]]
     [:div.name
      [:span.team-name (t name)]
      [:span.team-member-count
       (gstring/format (trn "%d Mitglied" "%d Mitglieder" member-count) member-count)]]
     (when goal-reached-date
       [:div.goal-reached-date.push-right [:i.sc_icon [icons/flag]] (format/date->short goal-reached-date)])
     [:div.steps {:class (when-not goal-reached-date "push-right")} (format/decimal team-step-count)]]))

(rf/reg-event-db ::participant-clicked
  (fn [db [_ team-id]]
    (open-team-members-modal db team-id)))

(defn- participant-row [{:keys [animation-pos nickname rank step-counts team-id]}]
  (let [challenge-started? @(rf/subscribe [::subs/challenge-started?])
        step-count (:total step-counts)]
    [:div.sc_leaderboard-row {:class (when (= nickname @(rf/subscribe [:get [:stepchall :participant :nickname]]))
                                       "own")
                              :style {:animation-delay (str (/ animation-pos 10) "s")}
                              :on-click #(rf/dispatch [::participant-clicked team-id])}

     [:div.rank (cond
                  (not challenge-started?) nil
                  (zero? step-count) "-"
                  :else rank)]
     [:div.name nickname]
     [:div.steps.push-right (format/decimal step-count)]]))

(defn- stage-row [{:keys [name num-steps is-goal? animation-pos]}]
  [:div.sc_leaderboard-stage {:class (when is-goal? "goal")
                              :style {:animation-delay (str (/ animation-pos 10) "s")}}
   [:span (when is-goal? [:i.sc_icon [icons/flag]]) (t name)]
   [:span (format/decimal num-steps)]])

(defn- placeholder-row []
  [:div.sc_leaderboard-row
   [:div.rank [:span.content-placeholder]]
   [:div.name [:span.content-placeholder]]
   [:div.steps.push-right [:span.content-placeholder]]])

(rf/reg-sub ::stages
  :<- [:get [:stepchall :stages]]
  :<- [:get [:stepchall :goal]]

  (fn [[stages goal] _]
    (->> stages
         (sort-by :num-steps)
         reverse
         (map #(assoc %
                      :is-goal? (= goal (:num-steps %))
                      :type :stage)))))

(rf/reg-sub ::count-participants
  :<- [:get [:stepchall :participants]]

  (fn [participants _]
    (count participants)))

(defn- subtitle []
  (let [{:keys [rank total items-name]} (case @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]])
                                          :teams {:rank @(rf/subscribe [:get [:stepchall :team :rank]])
                                                  :total @(rf/subscribe [::subs/count-teams])
                                                  :items-name (tr "Teams")}
                                          :participants {:rank @(rf/subscribe [:get [:stepchall :participant :rank]])
                                                         :total @(rf/subscribe [::count-participants])
                                                         :items-name (t {:de "Teilnehmern"
                                                                         :en "Participants"})})]
    [:div.sc_subtitle (when @(rf/subscribe [::subs/is-team-member?])
                        (trp-with-place-holders
                         {:de "Platz {rank} von {total} {items-name}"
                          :en "Rank {rank} of {total} {items-name}"}
                         {"rank" rank
                          "total" total
                          "items-name" items-name}))]))

(defn- table-header []
  (let [scope @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]])
        challenge-unit @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    [:div.sc_leaderboard-header
     [:div.member (t (case scope
                       :teams {:de "Teams"
                               :en "Teams"}
                       :participants {:de "Teilnehmende"
                                      :en "Participants"}))]
     [:div.steps (t challenge-unit)]]))

(rf/reg-event-db ::team-members-modal-close-clicked
  (fn [db _]
    (update-in db [:ui :page] dissoc :team-id)))

(defn- team-members-modal []
  (when-let [team-modal-id @(rf/subscribe [:get [:ui :page :team-id]])]
    [modal/modal {:content [(fn []
                              (let [team @(rf/subscribe [::leaderboard-team-by-id team-modal-id])]
                                [:div.sc_modal_team-members
                                 [:h4 {:style {:text-align "center"}} (t (:name team))]
                                 [team-members/team-members]]))]
                  :close-button {:on-click #(rf/dispatch [::team-members-modal-close-clicked])}}]))

(defn- animate [items]
  (map-indexed
   (fn [idx item] (assoc item :animation-pos (inc idx)))
   items))

(defn- greater-than? [item stage]
  (> (:num-steps stage) (:total (:step-counts item))))

(defn- add-stages-step [[results stages] item]
  (let [[these the-rest] (split-with (partial greater-than? item) stages)]
    [(-> (into results (take-last 1 these))
         (conj item))
     the-rest]))

(defn- add-stages [items stages]
  (->> items
       (reduce add-stages-step [[] stages])
       first))

(rf/reg-sub ::items
  :<- [::search/matching-teams :leaderboard]
  :<- [::search/matching-participants :leaderboard]
  :<- [:get [:ui :stepchall :leaderboard :scope]]
  :<- [:get [:stepchall :loaded-participants]]
  :<- [:get [:stepchall :total :participants]]

  (fn [[teams participants scope loaded-participants participants-count] _]
    (case scope
      :teams (map #(assoc % :type :team) teams)
      :participants (if (= loaded-participants :all)
                      (map #(assoc % :type :participant) participants)
                      (repeat (min participants-count 10)
                              {:type :placeholder})))))

(rf/reg-sub ::results
  :<- [:get [:ui :stepchall :leaderboard :scope]]
  :<- [::items]
  :<- [::pagination/leaderboard-page]
  :<- [::stages]

  (fn [[scope items page stages] _]
    (-> items
        (pagination/paginate page)
        (cond-> (= scope :teams) (add-stages stages))
        animate)))

(defn- table []
  (into [:<>]
        (map #(case (:type %)
                :participant ^{:key %} [participant-row %]
                :team ^{:key %} [team-row %]
                :stage ^{:key %} [stage-row %]
                :placeholder ^{:key %} [placeholder-row]))
        @(rf/subscribe [::results])))

(defn- empty-search []
  (let [scope @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]])]
    [:div {:style {:text-align "center"
                   :margin "2em 5em"
                   :line-height "1.75em"
                   :min-height "20em"}}
     (t (case scope
          :teams {:de "Sorry, Team nicht gefunden :("
                  :en "Sorry, team not found :("}
          :participants {:de "Sorry, Teilnehmer nicht gefunden :("
                         :en "Sorry, participant not found :("}))]))

(defn leaderboard []
  (let [scope @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]])
        items @(rf/subscribe [::items])]
    [:div.sc_content
     [:h2.sc_headline (tr "Bestenliste")]
     [subtitle]
     [leaderboard.nav/nav]
     [search/searchbar
      {:id :leaderboard
       :placeholder (case scope
                      :teams {:de "Team suchen…"
                              :en "Search teams…"}
                      :participants {:de "Teilnehmer suchen…"
                                     :en "Search participants…"})}]
     (if-not (seq items)
       [empty-search]
       [:div.sc_leaderboard
        [table-header]
        [table]
        [pagination/pagination]])
     [team-members-modal]]))

(rf/reg-event-fx ::navigate-to-stepchall-leaderboard
  (fn [{:keys [db]} _]
    (-> {:db db}
        (pagination/init-db)
        (search/init-db)
        (assoc-in [:db :ui :page] {:id :stepchall
                                   :subpage :leaderboard})
        (assoc-in [:db :ui :stepchall :leaderboard :scope] :teams)
        (assoc :scroll-to {:frame :app-frame
                           :mode :page-top})
        (api-events/api-requests-on-stepchall-event))))
